import React from 'react';
import { ArrowRight, Book } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function ProductsSection() {
  return <section id="productos" className="py-24 md:py-32 bg-neutral-950 border-t border-neutral-900" data-id="element-302">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-303">
        <FadeIn data-id="element-304">
          <div className="text-center mb-16" data-id="element-305">
            <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase mb-4" data-id="element-306">
              ¿Querés empezar hoy?
            </h2>
            <p className="text-neutral-400 text-lg max-w-2xl mx-auto" data-id="element-307">
              Tenés dos opciones de entrada directa para comenzar a estudiar el
              sistema a tu propio ritmo.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12" data-id="element-308">
          {/* Product 1 */}
          <FadeIn delay={0.1} data-id="element-309">
            <div className="bg-[#121212] border border-neutral-800 p-8 rounded-sm hover:border-neutral-600 transition-all flex flex-col h-full" data-id="element-310">
              <div className="w-12 h-12 bg-neutral-900 flex items-center justify-center rounded-sm border border-neutral-800 mb-6" data-id="element-311">
                <Book className="w-5 h-5 text-neutral-400" data-id="element-312" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-313">
                Ebook Sniper OTC
              </h3>
              <p className="text-neutral-400 text-sm mb-8 flex-grow" data-id="element-314">
                La guía escrita completa con el patrón 5-7, validación de ticks
                y reglas de ejecución.
              </p>
              <a href="https://protocolosniperotc.com/products/protocolosniper?variant=43460889903182" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between w-full border border-neutral-700 hover:border-white text-white py-3 px-6 rounded-sm transition-colors text-sm font-semibold" data-id="element-315">
                <span data-id="element-316">Ver Producto</span>
                <ArrowRight size={16} data-id="element-317" />
              </a>
            </div>
          </FadeIn>

          {/* Product 2 */}
          <FadeIn delay={0.2} data-id="element-318">
            <div className="bg-[#121212] border border-neutral-800 p-8 rounded-sm hover:border-neutral-600 transition-all flex flex-col h-full relative overflow-hidden" data-id="element-319">
              <div className="absolute top-0 right-0 bg-neutral-800 text-xs font-bold px-3 py-1 text-white tracking-wider" data-id="element-320">
                PACK
              </div>
              <div className="w-12 h-12 bg-neutral-900 flex items-center justify-center rounded-sm border border-neutral-800 mb-6" data-id="element-321">
                <Book className="w-5 h-5 text-white" data-id="element-322" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-323">
                Ebook + Lenguaje de Precio
              </h3>
              <p className="text-neutral-400 text-sm mb-8 flex-grow" data-id="element-324">
                El combo ideal para entender el fundamento del mercado y aplicar
                la ejecución precisa.
              </p>
              <a href="https://protocolosniperotc.com/products/pack-protocolo-sniper-introduccion-al-lenguaje-de-precio" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between w-full bg-white hover:bg-neutral-200 text-black py-3 px-6 rounded-sm transition-colors text-sm font-semibold" data-id="element-325">
                <span data-id="element-326">Ver Producto</span>
                <ArrowRight size={16} data-id="element-327" />
              </a>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-328">
          <div className="max-w-4xl mx-auto bg-neutral-900/50 border border-neutral-800/50 p-4 rounded-sm text-center" data-id="element-329">
            <p className="text-sm text-neutral-400" data-id="element-330">
              <strong className="text-neutral-300" data-id="element-331">Nota:</strong> Si luego
              entrás a la mentoría y ya tenés un producto, accedés a{' '}
              <span className="text-white border-b border-red-500/50" data-id="element-332">
                precio alumno
              </span>
              .
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}